/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setAppLockActivated} from '../api'

export const useMutationSetAppLockActivated = createReactQueryMutationHook('setAppLockActivated', setAppLockActivated)
